import { createSlice, PayloadAction, type WithSlice } from '@reduxjs/toolkit';
import type { AuthState, Permission, UserType } from './auth.types';
import { registerSliceInjection } from '@starjack/api';

export const initialState: AuthState = {
    jwt: null,
    refreshCode: null,
    validFor: 0,
    tokenExpiresAt: 0,
    userType: null,
    permissions: [],
    userId: null,
    liftOperatorData: null,
    logoutType: null,
};

export const authSlice = createSlice({
    name: 'authSlice',
    initialState: initialState,
    reducers: {
        setAuthData(
            state: AuthState,
            action: PayloadAction<{
                jwt: string;
                refreshCode: string;
                validFor: number;
                tokenExpiresAt: number;
                permissions: Permission[];
                userType: UserType;
                userId: string;
                liftOperatorData: {
                    skiOperator: string;
                    liftOperatorId: string;
                };
            }>
        ) {
            return {
                ...state,
                ...action.payload,
                logoutType: null,
            };
        },

        clearAuthData(
            _state: AuthState,
            action: PayloadAction<{ userLogout?: boolean }>
        ) {
            const userLogout = !!action.payload.userLogout;

            return {
                ...initialState,
                logoutType: userLogout ? 'userLogout' : null,
            };
        },
    },
});

export const authActions = {
    ...authSlice.actions,
};

// Auto-inject authSlice when this module is imported
// This happens automatically - no need to call any initialization function
registerSliceInjection((rootReducer) => {
    authSlice.injectInto(rootReducer);
});

// Auto-augment the global type registry
declare module '@starjack/api' {
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
    export interface LazyLoadedSlicesRegistry extends WithSlice<
        typeof authSlice
    > {}
}
